/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_ReorderedInputs */

const en_toast_reordered = /** @type {(inputs: Toast_ReorderedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order changed`)
};

const de_toast_reordered = /** @type {(inputs: Toast_ReorderedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge geändert`)
};

/**
* | output |
* | --- |
* | "Order changed" |
*
* @param {Toast_ReorderedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_reordered = /** @type {((inputs?: Toast_ReorderedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_ReorderedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_reordered(inputs)
	return en_toast_reordered(inputs)
});